import {
  GET_ESTADISTICAS_AVISO,
  GET_ESTADISTICAS_AVISO_SUCCESS,
  GET_ESTADISTICAS_AVISO_ERROR,
  EstadisticasState,
  InitialStateEstadisticas,
  EstadisticasActions,
} from './types'

const reducers = (state: any = InitialStateEstadisticas, action: EstadisticasActions): EstadisticasState => {
  switch (action.type) {
    case GET_ESTADISTICAS_AVISO:
      return {
        ...state,
        loading: true,
        error: false,
      }
    case GET_ESTADISTICAS_AVISO_SUCCESS:
      return {
        ...state,
        estadisticasAviso: action.payload,
        loading: false,
        error: false,
      }
    case GET_ESTADISTICAS_AVISO_ERROR:
      return {
        ...state,
        estadisticasAviso: null,
        loading: false,
        error: true,
      }
    default:
      return state
  }
}

export default reducers
